export default __webpack_public_path__ + "static/media/blog-level-1.d0043920.svg";